var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssembla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.7641 25.0232L52.0196 13.5159C50.2115 12.512 48.1651 12.0172 46.0981 12.0841C44.0221 12.0388 41.9698 12.5321 40.1411 13.5159L20.6972 25.0232C17.2856 27.3292 15.1985 31.1414 15.0938 35.2578V58.237C15.2065 62.36 17.3076 66.1735 20.7325 68.4717L40.3179 79.979C42.0871 80.9677 44.0897 81.4623 46.1157 81.4107C48.1435 81.4785 50.1504 80.9829 51.9136 79.979L71.6581 68.507C75.0937 66.176 77.2851 62.4111 77.615 58.2724V35.2932C77.5123 31.1047 75.3147 27.2473 71.7641 25.0232ZM60.3452 58.2724C60.164 58.3963 59.945 58.4526 59.7265 58.4315C59.2023 58.3907 58.7293 58.1016 58.4538 57.6537L50.6232 41.8688L42.7926 57.6184C42.5284 58.0774 42.0489 58.3704 41.5199 58.3961C41.3608 58.3961 41.0249 58.3961 40.9012 58.237C40.1993 57.8555 39.9384 56.978 40.3179 56.275L49.1561 38.7754L46.1688 32.8185L33.7953 57.7068C33.4439 58.395 32.601 58.668 31.9128 58.3166C31.2245 57.9651 30.9515 57.1223 31.303 56.4341L44.8784 29.1064C45.071 28.5835 45.5979 28.2615 46.1511 28.3287C46.6842 28.3406 47.17 28.6375 47.4238 29.1064L50.6409 35.7527L52.2141 38.7224L61.0522 56.3987C61.3553 57.1119 61.0438 57.9372 60.3452 58.2724Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssembla);
export default __webpack_public_path__ + "static/media/Assembla.48496302afcf44ccbb63ad26a5fae268.svg";
export { ForwardRef as ReactComponent };